define.alias("shared/components/shared/ui/social-profile-switcher", "media/components/shared/ui/social-profile-switcher");